module.exports = {
	active 			: false,
	color 			: '',
	time    		: 10000, // -1
	type    		: 'minimize', // minimize || middle
	is_minimizen 	: false,
	info 			: { 
		image  	: '/img/no_img_found.png',
		options : true,
		list    : {
			tag  		: '',
			device  	: '',
			probability : '',
			date 		: ''
		},
		
	},
	space : {
		list : 'ml-0', // ml-3
	}, 
	cols  :{
		image 	: 11, // 3
		list  	: 11, // 7
		options : 1
	},
	offset 	: {
		options : 0
	},
	size 	: {
		image : 200 + 'px', // 40
	},


}